export default __webpack_public_path__ + "9d2f928b49baf8ecc38633bd1d5af54e.png";